
import * as defaultImport from "@splunk/react-icons/ChevronLeft";
export * from "@splunk/react-icons/ChevronLeft";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
